import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import API from "../../../Services/BaseService";
import Popup from "../../../Component/Popup/Popup";
import ls from "local-storage";
import Loading from "../../../Component/Loading/Loading";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";

const ViewSellercheck = (props) => {

  const history = useHistory();
  const { car, billOfSaleId, sellerCarChargesId, billofsale, type } = props.location.state;
  const successData = useSelector(state => state.LoginReducer.payload);

  console.log("car id", car)
  console.log("BOS id", billofsale)
  const [seller, setSeller] = useState("")

  const [sellerCheckID, setSellerCheckID] = useState("");
  const [active, setActive] = useState("");
  const [isOpenDelete, setIsOpensDelete] = useState(false);
  const [BOSList, setBOSList] = useState("");
  const [feesList, setFeesList] = useState("");
  const [sellMiscFee, setSellMiscFee] = useState("");
  const [chargesListDetails, setChargesListDetails] = useState("");
  const [loading, setloading] = useState(true);
  const [sellerFee, setSellerFee] = useState("")
  const [sellerChargesList, setSellerChargeslist] = useState("")
  const [carChargesList, setCarChargeslist] = useState("")
  const [miscFeeList, setMiscFeelist] = useState("")
  const [dropValues, setDropValues] = useState("");
  const [check, setCheck] = useState("")

  const togglePopupDelete = () => {
    setIsOpensDelete(!isOpenDelete);
  };


  const billofSaleView = () => {
    let request = {
      bill_of_sale_id: billofsale,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    };

    API.post("billofsaleById/condition", request).then((response) => {
      setBOSList(response.data?.data[0]);
      setFeesList(response.data?.data[0]?.sellerfeechargeslist);
    });
  };

  // const sellerViewDetails = () => {

  //   let request = {
  //     car_id: car,
  //     seller_id: successData.seller_id,
  //     seller_token: successData.seller_token,
  //   }
  //   API.post("seller_check/condition", request).then((response) => {
  //     console.log("mailBankAccount", response.data.data);
  //     setSeller(response.data?.data[0]);
  //     setloading(false);

  //   });
  // };

  useEffect(() => {
    billofSaleView();

    sellerViewDetails();
    sellerMiscFee();
    chargeList();
  }, []);



  const handleDelete = (data) => {
    setSellerCheckID(data?.seller_check_id);
    setActive(data?.active)
    togglePopupDelete();
  };

  const redirectionCar = (car_id) => {
    history.push({ pathname: "/viewvehicleinfo", state: { backURL: "/cars" } });
    ls.set("carId", car_id);
  };
  const redirectionSeller = (seller_dealer_id) => {

    history.push({
      pathname: "/sellerviewinfo",
      state: { backURL: "/billofsaleedit" },
    });
    ls.set("sellerDealerId", seller_dealer_id);
  };

  const redirection = (bill_of_sale_id) => {
    history.push({
      pathname: "/billofsaleview",
      state: { backURL: "/billofsale" },
    });
    ls.set("billOfSaleId", bill_of_sale_id);
    console.log("billOfSaleId", billOfSaleId);
  };


  const sellerMiscFee = () => {
    let request = {
      bill_of_sale_id: billofsale,
    };

    API.post("billofsalesellerMiscFee/condition", request).then((response) => {
      setSellMiscFee(response.data?.data);
    }
    );
  };

  const sellerViewDetails = () => {

    let request = {
      car_id: car,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      bill_of_sale_id: billofsale

    }
    API.post("seller_checks/condition", request).then((response) => {
      // console.log("mailBankAccount", response.data.data);
      if (response.data.success === true) {

        setSeller(response.data.data[0]);
        setCheck(response.data.data[0].check_seller)
        const value = response.data.data[0].void_status == "1" ? "Generated" : response.data.data[0].void_status == "3" ? "Unclear" : response.data.data[0].void_status == "5" ? "Clear" : response.data.data[0].void_status == "4" ? "Voided" : ""
        setDropValues(value)
        setMiscFeelist(response.data.data[0].sellerMiscFeelist)
        setSellerFee(response.data.data[0].bidpricesellerlist.filter(data => data.type == "sellerfee"))
        setCarChargeslist(response.data.data[0].carchargesList)
        setSellerChargeslist(response.data.data[0].sellerindividualchargesList)
        setloading(false);
      }
    })
    // .catch(function (error) {
    //   if (error.response) {
    //     setErrors(error.response.data.error)
    //     setErrorFlag(true)
    //   }
    // });
  };

  const chargeList = () => {

    let request = {
      car_charges_id: sellerCarChargesId,
    }
    API.post("miscDetaillist/condition", request).then(response => {
      setChargesListDetails(response.data?.data);
    });
  }

  function convertUTCDateToLocalDate(data) {
    if (data === null || data === "" || data === undefined) {
      return data;
    }
    else {
      var dateLocal = new Date(data);
      var newDate = new Date(dateLocal.getTime() - (dateLocal.getTimezoneOffset()) * 60 * 1000);
      var value = moment(newDate).format('MMMM D, YYYY hh:mm A')
      return value;
    }

  }

  return (
    <main id="main" className="inner-page">
      {loading ? <Loading /> :
        <div class="container-fluid inner-page-space billof-sec">

          <div class="back-btn">
            <a class="back-btn-primary" onClick={() => history.goBack()}>
              <i class="bx bx-chevron-left"></i> Back
            </a>
          </div>

          <div class="section-title pb-0">
            <h2>{type == "Ach" ? "Seller Ach" : "Seller Check"}</h2>
          </div>

          <div class="sellercheck-sec">
            <div class="row">
              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" defaultValue={seller.bill_of_sale_id} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="bos#" class="input-has-value">BillofSale #</label>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="inventory#" defaultValue={seller.car_id} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="inventory#" class="input-has-value">Inventory #</label>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  {type !== "Ach" ?
                    <input type="text" id="seller#" defaultValue={dropValues} disabled className="form-control textbox" placeholder="" /> :
                    <input type="text" id="seller#" defaultValue={seller.Ach_status == "Active" ? "Generated" : seller.Ach_status} disabled className="form-control textbox" placeholder="" />}

                  <label htmlFor="seller#" class="input-has-value">Status</label>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="seller#" defaultValue={seller.seller_id} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="seller#" class="input-has-value">Seller #</label>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="sellername#" defaultValue={seller.check_seller_name} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="sellername#" class="input-has-value">Seller Name</label>
                </div>
              </div>

              {type == "Ach" ? "" :
                <>
                  <div className="col-md-6 col-lg-4 form-group">
                    <div className="tbox">
                      <input type="text" id="bankacc" defaultValue={seller.check_seller_defaultbank_name} className="form-control textbox" placeholder="" disabled />
                      <label htmlFor="bankacc" class="input-has-value">Bank Account</label>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 form-group">
                    <div className="tbox">
                      <input type="text" id="Check" class="form-control textbox"
                        aria-label="Recipient's username" aria-describedby="button-addon2" defaultValue={type == "Ach" ? seller.ach_no : seller.check_seller} disabled />
                      <label for="Check" class="input-has-value">{type == "Ach" ? "ACH" : "Check"} No</label>
                    </div>
                  </div>
                </>}

              {/* <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="Check #" defaultValue={seller.check_seller} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="Check #" class="input-has-value">Check #</label>
                </div>
              </div> */}

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="amount" defaultValue={seller.car_price} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="amount" class="input-has-value">Amount</label>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="chargeinventory" value={seller.totalamountpaid} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="chargeinventory" class="input-has-value">Charge to inventory</label>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="chargeinventory" className="form-control textbox" defaultValue={type == "Ach" ? convertUTCDateToLocalDate(seller.ach_created_date_tz) : seller.seller_checkdate} disabled />
                  <label htmlFor="chargeinventory" class="input-has-value">{type == "Ach" ? "ACH" : "Check"} Date</label>
                </div>
              </div>
              {type == "Ach" ? "" :
                <div className="col-md-6 col-lg-4 form-group">
                  <div className="tbox">
                    <input type="text" id="chargeinventory" defaultValue={seller.check_admin_bank_account} className="form-control textbox" placeholder="" disabled />
                    <label htmlFor="chargeinventory" class="input-has-value">Check Bank Account</label>
                  </div>
                </div>}

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <input type="text" id="payseller" defaultValue={type == "Ach" ? seller.pay_to_seller_ach : seller?.paytoseller} className="form-control textbox" placeholder="" disabled />
                  <label htmlFor="payseller" class="input-has-value">Amount after deduction</label>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 form-group">
                <div className="tbox">
                  <textarea className="form-control textbox" id="internal" rows="2" defaultValue={type == "Ach" ? seller.description_ach : seller.check_description} ></textarea>
                  <label htmlFor="payseller" class="input-has-value">Description</label>
                </div>
              </div>

            </div>

            <h5>Charges Amount</h5>

            <div className="userlisttable table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th className="th_id">S.NO</th>
                    <th className="th_name">Names</th>
                    <th className="th_phone">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr ><h5> Special Fees</h5></tr>
                  {seller?.specialfeesellerlist?.length > 0 ? seller.specialfeesellerlist.map((item, index) =>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item?.billofsale_sellerfee_chargename}</td>
                      <td>{item?.amountpaid}</td>
                    </tr>
                  ) : ""}
                  {sellerFee[0]?.amountpaid > 0 ? <tr ><h3> Seller Fee</h3></tr> : ""}
                  {sellerFee[0]?.amountpaid > 0 ?
                    <tr>
                      <td><b>{1}</b></td>
                      <td><b>{sellerFee[0]?.billofsale_sellerfee_chargename}</b></td>
                      <td><b>{sellerFee[0]?.amountpaid ? sellerFee[0]?.amountpaid : 0}</b></td>
                    </tr>
                    : ""}
                  {miscFeeList?.length > 0 ? <tr ><h3> Miscellaneous Fee</h3></tr> : ""}
                  {miscFeeList?.length > 0 ? miscFeeList?.map((item, index) => (
                    <tr>
                      <td><b>{index + 1}</b></td>
                      <td><b>{item?.billofsale_sellerfee_chargename}</b></td>
                      <td><b>{item?.amountpaid}</b></td>
                    </tr>
                  )) : ""}
                  {sellerChargesList?.length > 0 ? <tr ><h3> Seller Charges</h3></tr> : ""}
                  {sellerChargesList?.length > 0 ? sellerChargesList.map((item, index) => (
                    <tr>
                      <td><b>{index + 1}</b></td>
                      <td><b>{item?.charges_name}</b></td>
                      <td><b>{item?.amountpaid}</b></td>
                    </tr>
                  )) : ""}
                  {carChargesList?.length > 0 ? <tr><h3> Car Charges</h3></tr> : ""}
                  {carChargesList?.length > 0 ? carChargesList.map((item, index) => (
                    <tr>
                      <td><b>{index + 1}</b></td>
                      <td><b>{item?.charges_name}</b></td>
                      <td><b>{item?.amountpaid}</b></td>
                    </tr>
                  )) : ""}
                  <tr>
                    <td></td>
                    <td><h5>Pay to Seller</h5></td>
                    <td><h5>{type == "Ach" ? seller.pay_to_seller_ach : seller?.paytoseller}</h5></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>}


    </main >
  )
}
export default ViewSellercheck;